"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Heart = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("g", { id: "Reaction-/-Meduim-/-Heart_Meduim_24X24", stroke: "none", fill: "none", strokeWidth: "1", fillRule: "evenodd" },
            React.createElement("path", { d: "M0.409,11.0514 C1.743,15.4504 8.842,20.6224 11.225,22.2554 C11.7,22.5804 12.305,22.5804 12.78,22.2554 C15.162,20.6214 22.255,15.4504 23.591,11.0514 C23.98,9.9234 24.111,8.6584 23.899,7.3424 C23.437,4.4674 21.289,2.1324 18.609,1.6164 C15.897,1.0954 13.417,2.3464 12,4.4694 C10.583,2.3454 8.102,1.0954 5.391,1.6164 C2.711,2.1324 0.563,4.4674 0.1,7.3434 C-0.111,8.6584 0.02,9.9234 0.409,11.0514", id: "Heart", fill: "#F5592D" }))));
};
Heart.displayName = 'Heart';
exports.default = Heart;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Heart.js.map